<!-- Editor Mode: Mat-toolbar with back button and title -->
@if (mode() === 'editor') {
  <mat-toolbar class="toolbar top element-shadow">
    <div class="toolbar-left">
      @if (showBackButton()) {
        <button class="icon-btn toolbar-back-btn" (click)="onBackClick()" [matTooltip]="'back' | transloco">
          <q-svg-wrapper iconPath="project-icons/arrow" width="24" height="24" viewBox="0 0 24 24"></q-svg-wrapper>
        </button>
      }
      <a routerLink="/" class="logo-link">
        <img class="logo" src="assets/vectors/logo.svg" alt="QuestAtlas" />
      </a>
      <span class="toolbar-divider"></span>
      <span class="main-heading-text">{{ title() | transloco }}</span>
    </div>

    @if (buttons().length > 0) {
      <div class="toolbar-actions">
        @for (button of buttons(); track $index) {
          <button
            [class]="button.type === 'primary' ? 'primary-bar-btn' : 'secondary-bar-btn'"
            (click)="button.onClick()"
            [disabled]="isButtonDisabled(button)">
            {{ button.label | transloco }}
          </button>
        }
      </div>
    }
  </mat-toolbar>
}

<!-- View Mode: Simple header with logo and action buttons -->
@if (mode() === 'view') {
  <header class="page-header">
    <a href="https://questatlas.world" target="_blank" class="logo-link">
      <img src="assets/vectors/logo.svg" alt="QuestAtlas" class="logo" />
    </a>

    @if (buttons().length > 0) {
      <div class="header-actions">
        @for (button of buttons(); track $index) {
          <button
            [class]="button.type === 'primary' ? 'action-btn' : 'action-btn secondary'"
            (click)="button.onClick()"
            [disabled]="isButtonDisabled(button)">
            @if (button.icon) {
              <q-svg-wrapper [iconPath]="button.icon" width="20" height="20" viewBox="0 0 24 24"></q-svg-wrapper>
            }
            {{ button.label | transloco }}
          </button>
        }
      </div>
    }
  </header>
}

